<template>
    <v-dialog width="fit-content" v-model="dialog">
        <template v-slot:activator="{ on }" class="primary">
            <v-btn
                x-small
                icon
                color="grey lighten-1"
                v-on="on"
                @click.stop="dialog = true"
            ><v-icon style="font-size: 20px;">mdi-pencil</v-icon>
            </v-btn>
        </template>

        <v-card>
            <v-card-title>
                <span class="headline">Edit option</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-form ref="form">
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Key*"
                                        hint="enter key"
                                        required
                                        disabled
                                        v-model="okey"
                                        :error-messages="okeyErrors"
                                        @input="$v.okey.$touch()"
                                        @blur="$v.okey.$touch()"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Value*"
                                        hint="enter value"
                                        v-model="ovalue"
                                        :error-messages="ovalueErrors"
                                        required
                                        disabled
                                        @input="$v.ovalue.$touch()"
                                        @blur="$v.ovalue.$touch()"
                                ></v-text-field>
                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    append-icon="mdi-magnify"
                                    clear-icon="mdi-close"
                                    clearable
                                    outlined
                                    label="Address"
                                    hint="type something to search"
                                    v-model="address"
                                    persistent-hint
                                    @change="onAddressChanged()"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <h2 v-if="gmap_results.length != 0">Seach results:</h2>
                                <h3 v-if="gmap_loading">Seaching address...</h3>
                                <v-list-item-group color="primary">
                                    <v-list-item
                                        v-for="(item, i) in gmap_results"
                                        :key="i"
                                        @click="onSelectAddress(item)"
                                    >
                                        <v-list-item-icon class="driver-profile_icon">
                                            <v-icon>mdi-map-marker</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="item.formatted_address"></v-list-item-title>
                                            <!-- <v-list-item-subtitle>sub</v-list-item-subtitle> -->
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <GmapMap
                                    ref="mapRef"
                                    :options="{
                                        zoomControl: true,
                                        mapTypeControl: false,
                                        scaleControl: true,
                                        streetViewControl: false,
                                        rotateControl: false,
                                        fullscreenControl: true,
                                        disableDefaultUi: false
                                    }"
                                    :center="map_center"
                                    :zoom="map_zoom"
                                    map-type-id="terrain"
                                    style="width: 100%; height: 220px"
                                    @click="onChangeMarkerPosition"
                                    @zoom_changed="onChangeZoom"
                                >
                                    <GmapMarker v-if="map_marker" :position="map_marker" />
                                </GmapMap>
                            </v-col>
                        </v-row>

                        <div class="d-flex justify-center">
                            <v-btn
                                    depressed
                                    class="mr-4 primary"
                                    :disabled="this.$v.$invalid || localLoading"
                                    @click="submit"
                                    :loading="localLoading"
                            >
                                <v-icon left>mdi-check-box-outline</v-icon>
                                Accept Changes
                            </v-btn>
                            <v-btn
                                    class="warning"
                                    depressed
                                    @click="cancel"
                                    :loading="localLoading"
                            >
                                <v-icon left>mdi-cancel</v-icon>
                                Cancel
                            </v-btn>
                        </div>

                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import {gmapApi} from 'vue2-google-maps'
    import * as _ from 'lodash'
    import axios from 'axios'

    const DEFAULT_MAP_CENTER = {lat:51.4, lng:0}; // default London

    export default {
        mixins: [validationMixin],
        name: "EditOptionModal",
        props: ['thisOptionData'],
        validations: {
            okey: {required},
            ovalue: {required, /* maxLength: maxLength(10)*/},
        },
        data: () => ({
            optionData: null,
            localLoading: false,
            dialog: false,
            okey: '',
            ovalue: '',
            //
            address: '',
            map_latitude: void 0,
            map_longitude: void 0,
            is_initialized: false,
            map_center: DEFAULT_MAP_CENTER, // default: London
            map_zoom: 12,
            map_marker: void 0,
            gmap_results: [],
            gmap_loading: false,
        }),
        computed: {
            okeyErrors () {
                const errors = []
                if (!this.$v.okey.$dirty) return errors
                /*!this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')*/
                !this.$v.okey.required && errors.push('First name is required.')
                return errors
            },
            ovalueErrors () {
                const errors = []
                if (!this.$v.ovalue.$dirty) return errors
                !this.$v.ovalue.required && errors.push('Last Name is required.')
                return errors
            },
            google: gmapApi,
        },
        updated() {
            if (this.is_initialized) {
                return;
            }

            let me = this;
            let timerId = setInterval(() => { // await while google load scripts
                if(!me.google || !me.$refs.mapRef) {
                    return;
                }

                clearInterval(timerId);
                me.$data.is_initialized = true;

                me.onUpgradeMapMarker();
            }, 10);
        },
        mounted() {
            this.optionData = this.thisOptionData;
            this.okey = this.thisOptionData.okey;
            this.ovalue = this.thisOptionData.ovalue;

            let map_options = JSON.parse(this.ovalue);

            this.map_latitude = map_options.lat; // 51.4
            this.map_longitude = map_options.lng; // 0
            this.map_center = {
                lat: this.map_latitude,
                lng: this.map_longitude
            };
            this.map_zoom = map_options.map_zoom; // 8
        },
        methods: {
            cancel(){
                this.okey = this.thisOptionData.okey;
                this.ovalue = this.thisOptionData.ovalue;

                this.dialog = false;
            },
            submit () {
                this.localLoading = true;
                this.dialog = true;
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    const option_data = {
                        okey: this.okey,
                        ovalue: this.ovalue,
                    };

                    if (this.switch_change_password) {
                        option_data.password = this.password;
                    }

                    this.$store.dispatch('editOption', option_data).then(() => {
                        this.dialog = false;
                        this.$emit('optionUpdated', '');
                    })
                    .catch(error => {
                        this.email = '';
                        let errors = error.response;
                        this.$store.dispatch('setError', errors[Object.keys(errors)[0]][0]);
                    }).finally(() => {
                        this.localLoading = false;
                    });
                }
            },

            refreshValue() {
                this.ovalue = JSON.stringify({
                    lat: this.map_latitude,
                    lng: this.map_longitude,
                    map_zoom: this.map_zoom,
                });
            },

            onAddressChanged() {
                if (!this.$data.address) {
                    return;
                }

                this.gmap_loading = true;
                let searchStr = encodeURI(this.$data.address.split(' ').join('+'));
                axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${searchStr}&key=${this.appConfig.GOOGLE_MAP_API_KEY}&language=en`)
                    .then(result => {
                        this.gmap_loading = false;
                        this.$data.gmap_results = result.data && result.data.results;
                    });
            },
            onSelectAddress(item) {
                this.address = item.formatted_address;

                let postal_code = _.find(item.address_components, (p) => p.types.indexOf('postal_code') !== -1);
                if (postal_code) {
                    this.postcode = postal_code.short_name;
                }
                
                this.map_latitude = _.get(item, 'geometry.location.lat', void 0);
                this.map_longitude = _.get(item, 'geometry.location.lng', void 0);

                if (this.map_latitude && this.map_longitude) {
                    this.onUpgradeMapMarker();
                }
            },
            onUpgradeMapMarker() {
                let me = this;

                me.$data.map_marker = void 0;
                if (!me.map_latitude || !me.map_longitude) {
                    return;
                }

                me.$refs.mapRef.$mapPromise.then((map) => {
                    me.$data.map_marker = new me.google.maps.LatLng(
                        me.map_latitude,
                        me.map_longitude
                    );

                    var bounds = new me.google.maps.LatLngBounds();
                    bounds.extend(me.$data.map_marker);
                    
                    map.setCenter(bounds.getCenter()); //or use custom center
                    map.setZoom(this.map_zoom);
                });

                this.refreshValue();
            },
            onChangeMarkerPosition(marker) {
                if (this.map_latitude || this.map_longitude) {
                    this.map_latitude = void 0;
                    this.map_longitude = void 0;
                } else {
                    this.map_latitude = marker.latLng.lat();
                    this.map_longitude = marker.latLng.lng();
                }

                this.onUpgradeMapMarker();
            },
            onChangeZoom(zoom) {
                this.map_zoom = zoom;
                this.refreshValue();
            }
        },
    }
</script>

<style scoped>

</style>
